'use client'

import { createContext, FC, ReactNode, useContext, useState } from 'react'

export enum CartActionType {
  SINGLEPRODUCT = 'singleProduct',
  MULTIPLEPRODUCTS = 'multipleProducts',
  CLEARCART = 'clearCart',
}

export type AssistiveCartActionData = {
  cartItems?: any
  product?: { displayName: string; productErpIdentifier: string; newQuantity: number }
  numberOfProducts?: number
}

type AssistiveCartContextType = {
  type: CartActionType
  actionData: AssistiveCartActionData
}

interface ContextType {
  assistiveCartData: AssistiveCartContextType | null
  setAssistiveCartData: (newValue: AssistiveCartContextType) => void
}

const AssistiveCartContext = createContext<ContextType | null>(null)

interface AssistiveCartProviderProps {
  children: ReactNode
}

export const AssistiveCartProvider: FC<AssistiveCartProviderProps> = ({ children }) => {
  const [assistiveCartData, setAssistiveCartData] = useState<AssistiveCartContextType | null>(null)

  return (
    <AssistiveCartContext value={{ assistiveCartData, setAssistiveCartData }}>
      {children}
    </AssistiveCartContext>
  )
}

export const useAssistiveCartContext = (): ContextType => {
  const context = useContext(AssistiveCartContext)
  if (!context) {
    throw new Error('useAssistiveCartContext must be used within a AssistiveCartProvider')
  }
  return context
}
